import axios from 'axios';
import { CohortMembersCountResponse } from './Summary';
import properties from '../../properties';

export const getCohortMemberCountForMedpharma = async (
  eg_nid: string[],
  incurredStartDate: string,
  incurredEndDate: string,
  paidStartDate: string,
  paidEndDate: string,
  aggregationParameter: string,
): Promise<CohortMembersCountResponse> => {
  const response = await axios.post(
    properties.aiqBaseUrl +
      properties.pharmacySpend +
      properties.getCohortMemberCountForMedpharma,
    {
      eg_nid,
      incurredStartDate,
      incurredEndDate,
      paidStartDate,
      paidEndDate,
      aggregationParameter,
    },
  );
  return response.data.data;
};

export const getCohortMemberCountForOtherDrugs = async (
  eg_nid: string[],
  incurredStartDate: string,
  incurredEndDate: string,
  paidStartDate: string,
  paidEndDate: string,
  aggregationParameter: string,
  claim_type: string,
  speciality_drug_type: string,
): Promise<CohortMembersCountResponse> => {
  const response = await axios.post(
    properties.aiqBaseUrl +
      properties.pharmacySpend +
      properties.getCohortMemberCountForOtherDrugs,
    {
      eg_nid,
      incurredStartDate,
      incurredEndDate,
      paidStartDate,
      paidEndDate,
      aggregationParameter,
      claim_type,
      speciality_drug_type,
    },
  );
  return response.data.data;
};
